import { IEntity } from 'interfaces/entity';
import * as rxjs from 'rxjs';
import { Observable } from 'rxjs';
import RxOp, { ICacheResult, IOptions } from 'rxjs-operators';
import selectedVentureService from 'services/profile';

import apiService, { ApiService } from './api';
import { IPaginationParams, IPaginationResponse } from '../interfaces/pagination';

export class EntityService {
  private key = 'entities-structures';

  constructor(private apiService: ApiService) {
  }

  public fetchEntitiesGraph(ventureId?: number, options?: Partial<IOptions>): rxjs.Observable<ICacheResult<IEntity[]>> {
    const url = ventureId ? `/entities/venture/${ventureId}` : '/entities';
    return this.apiService.get(url).pipe(
      RxOp.cache(`${this.key}-${ventureId || 'all'}`, {
        persist: true,
        refresh: false,
        expirationMinutes: 1,
        ...options
      })
    );
  }

  public list(
    params: IPaginationParams,
  ): Observable<IPaginationResponse<IEntity>> {
    const url = '/entities/list';
    return this.apiService.get(url, { ...params });
  }

  public refreshEntities() {
    return selectedVentureService
      .getSelectedVenture()
      .subscribe(selection => {
        if (selection && selection.id) {
          entityService.cleanEntityGraph().subscribe(() => {
            entityService.fetchEntitiesGraph(selection.id, { refresh: true }).subscribe();
          });
        }
      });
  }

  public cleanEntityGraph() {
    return RxOp.cacheClean(this.key)(rxjs.of(null));
  }

  public save(model: IEntity): Observable<IEntity> {
    return this.apiService.post('/entities', model);
  }

  public delete(id: number): Observable<void> {
    return this.apiService.delete(`/entities/${id}`);
  }
}

const entityService = new EntityService(apiService);
export default entityService;